import '../styles/thankyou.css';

const Thankyou = () => {
    return (
        <div className="container thankyou">
            <div className="row pt-5">
                <p>Thankyou for contacting us. <span><img className='svg-icon-medium' src="/assets/icons/heart.svg" alt="arrow" /></span>
                    <br />We have received your message and will reach out to you shortly!
                </p>
            </div>
        </div>
    );
}

export default Thankyou;